export const dateToEnUsFormat = (date: string, hyphen?: boolean) => {
  const day = date.substring(0, 2)
  const month = date.substring(2, 4)
  const year = date.substring(4, 8)

  const dividerSymbol = hyphen ? '-' : '/'

  return `${month}${dividerSymbol}${day}${dividerSymbol}${year}`
}
